/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CalendarEventType = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        type: {
    type: 'string',
    isRequired: true,
},
        color: {
    type: 'string',
    isRequired: true,
},
    },
};